export default __webpack_public_path__ + "static/media/landing-banner-image.8d3c9c2e.png";